import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import cloudbase from "@cloudbase/js-sdk";
import "element-ui/lib/theme-chalk/index.css";
import mixpanel from 'mixpanel-browser';
import { mixpanelConfig } from './config/mixpanel';

Vue.config.productionTip = false;
Vue.use(ElementUI);

// 初始化Mixpanel
try {
  mixpanel.init(mixpanelConfig.projectToken, mixpanelConfig.options);
  
  // 将Mixpanel添加到Vue原型，方便在组件中使用
  Vue.prototype.$mixpanel = mixpanel;
  
  // 仅在开发环境暴露到window对象，方便调试
  if (process.env.NODE_ENV === 'development') {
    window.$mixpanel = mixpanel;
    console.log('[Mixpanel] 初始化成功');
    console.log('[Mixpanel] 调试提示：在控制台输入 window.$mixpanel 查看对象');
  }
} catch (error) {
  // 初始化失败的错误日志保留，方便排查问题
  console.error('[Mixpanel] 初始化失败:', error);
  
  // 提供一个空的Mixpanel对象，避免代码报错
  const emptyMixpanel = {
    track: () => {},
    identify: () => {},
    people: {
      set: () => {}
    },
    get_distinct_id: () => 'not-initialized',
    get_config: () => ({})
  };
  
  Vue.prototype.$mixpanel = emptyMixpanel;
  
  // 开发环境也暴露空对象到window
  if (process.env.NODE_ENV === 'development') {
    window.$mixpanel = emptyMixpanel;
  }
}

const AV = require("leancloud-storage");
Vue.prototype.$AV = AV;

AV.init({
            appId:"6IkiQ1QmPKMayoS8DKVi7067-gzGzoHsz",
            appKey:"z2mzXszuCiHLIiru2XNSwAb9",
            serverURLs:'https://api.xiaobaoming.com'
});
//AV.setProduction(0)

Vue.prototype.bus = new Vue();
Vue.prototype.setSessionItem = function (key, newVal) {
  // 创建 StorageEvent 事件
  let newStorageEvent = document.createEvent("StorageEvent");
  const storage = {
    setItem: function (k, val) {
      localStorage.setItem(k, val);

      // 初始化 StorageEvent 事件
      newStorageEvent.initStorageEvent(
        "setItem", // 事件别名
        false,
        false,
        k,
        null,
        val,
        null,
        null
      );
      // 派发事件
      window.dispatchEvent(newStorageEvent);
    },
  };
  return storage.setItem(key, newVal);
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
